import React, { useState } from "react";
import AuthBackground from "../../components/LandingpageComp/Auth/AuthBackground";
import { createBrowserHistory } from "history";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";

function ForgetPassword() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const history = createBrowserHistory();

  const ForgetPasswordHandler = () => {
    if (!email) {
      toast.error("please enter correct email");
    } else {
      let data = { email: email };
      // dispatch(forgotPasswordEmail(data))
      history.push("/otpverification");
    }
  };

  return (
    <>
      <section className="forget">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 p-0">
              <AuthBackground />
            </div>
            <div className="col-lg-6 p-0">
              <div className="radianceFrom">
                <div className="form-Flex">
                  <div className="logoDv">
                    <figure>
                      {/* <img src={blueLogo} alt="" /> */}
                    </figure>
                  </div>
                  <h2 className="title blueish">Forget Password</h2>
                  <div className="textDv">
                    <h4 className="subtext authText">
                      Please Enter Your Email Below
                    </h4>
                    <h4 className="bld authText-sub">
                      <strong>We will send you a recovery code</strong>
                    </h4>
                  </div>
                  <form>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <button
                        className="form-control btn"
                        type="submit"
                        onClick={() => {
                          ForgetPasswordHandler();
                          // history.push("/otpverification");
                        }}
                        disabled={loading}
                      >
                        {loading ? "Loading..." : "Submit"}
                      </button>
                    </div>
                    <div className="privacyDv">
                      <h5>
                        By Creating Account you are agree to our{" "}
                        <a className="blueish" href="">
                          Terms & Conditions
                        </a>
                      </h5>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ForgetPassword;
